<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <!-- <h2>第一回</h2> -->

              <comic-block class="mb-4" :src="require(`@/assets/images/comics/comic4.jpg`)"></comic-block>

              <move-to-stage-btn link="時空警察">繼續</move-to-stage-btn>

              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>

      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage5_1',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第五章 - 1',
      isQuestion: false,
      stageId: 'comic3',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
